import { env } from '@skin-seoul/env-utils';

import axios, { AxiosInstance, CreateAxiosDefaults } from 'axios';

/**
 * you can use next cache with fetchOptions
 *
 * example:
 * const { data } = await client.get('/products', {
 *   fetchOptions: {
 *     next: {
 *       revalidate: 60,
 *     },
 *     cache: 'force-cache',
 *   },
 */

const getBaseURL = () => {
  switch (env('NEXT_PUBLIC_ENV')) {
    case 'LOCAL':
      return env('NEXT_PUBLIC_ENV_SERVER_ORIGIN');
    case 'DEV':
      return 'https://dev.skin-seoul.com/api';
    case 'STAGING':
      return 'https://staging.skin-seoul.com/api';
    case 'PROD':
      return 'https://skin-seoul.com/api';
    default:
      return 'https://dev.skin-seoul.com/api';
  }
};

let _client: AxiosInstance | null = null;

const createSkinSeoulClient = (): AxiosInstance => {
  if (!_client) {
    const baseURL = getBaseURL();

    // Debug logging for environment context
    const isServer = typeof window === 'undefined';
    const hasGlobalEnv = typeof globalThis !== 'undefined' && !!(globalThis as any).__ENV;

    console.debug('[service/client] Creating HTTP client:', {
      isServer,
      hasGlobalEnv,
      baseURL,
      envSource: hasGlobalEnv ? 'globalThis.__ENV' : 'process.env or fallback',
    });

    _client = axios.create({
      baseURL,
      withCredentials: true,
      adapter: 'fetch',
    });
  }
  return _client;
};

export const cartClient: AxiosInstance = createSkinSeoulClient();
